import * as APIBase from './APIBase';

export default class UpdateRemoteSubscription {
  static get() {
    return APIBase.getUpdatedRemoteStatus();
  }
}
